import { render, staticRenderFns } from "./type-grid.vue?vue&type=template&id=1ffa5207&scoped=true&"
import script from "./type-grid.vue?vue&type=script&lang=js&"
export * from "./type-grid.vue?vue&type=script&lang=js&"
import style0 from "./type-grid.vue?vue&type=style&index=0&id=1ffa5207&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa5207",
  null
  
)

export default component.exports